import React from "react";
import DashBoardFavoriteDetails from "../../components/DashBoard/DashBoardFavoriteDetails";

import { useTripLegs } from "../../hooks/useTripLegs";
import GoogleLoader from "../../assets/Loader/GoogleSvgLoader/GoogleLoader";

const FavoriteDetailsContainer = () => {
  const { tripLegs, setTripLegs, isLoading } = useTripLegs();

  return isLoading ? (
    <GoogleLoader />
  ) : (
    <DashBoardFavoriteDetails trips={tripLegs} setTripLegs={setTripLegs} />
  );
};
export default FavoriteDetailsContainer;
